import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChryslerComponent } from './simple-icons-chrysler.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChryslerComponent ],
    exports:      [ SimpleIconsChryslerComponent ],
    bootstrap:    []
})
export class SimpleIconsChryslerModule {}
